var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.431885,
    width: 78,
    height: 74.7566,
    fill: "url(#pattern0_263_1312)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_263_1312",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_263_1312",
    transform: "matrix(0.0106491 0 0 0.0111111 0.0207907 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_263_1312",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB5ElEQVR4nO3dMW4UQRQA0R8ZjmBsjoghw5zQNhHmKMgkRIVGTOBgEySPtQ+6pE026apW60/4ZxaLxeK8qN5Wn6qv1c/Oj83pofpYvRmR6n31PYfHzXnAlyxd8vPLdl72Pi5UbkZhn8kq96NQPeXyNArhjEI4oxDOKCgBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEePIBIZ58QIgnHxDiyQeEeP51gMIohDMK4YzCQf2/qs/V1f673f97cUbhiPjq9sQ522W/OKNwRHz17sQ5l0ccNApHxFdXJ865PuKgUXjF0fHliING4Yj4/nz4tpm8Pob/yMKbH6OwVji9Evt+QJUPo7CtqttX1ml8qy4GXBz5iF3y9YjsL/tmm3tn+oHcnO62ccG95MViMf8BvwFzKJXoNOCy3gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.adb45e477fcf344f27a1963c038372c5.svg";
export { ForwardRef as ReactComponent };